import requests from "./api/base-api";

const TicketService = {
  getMyTickets: () =>
    requests.get("/ticket/v1/get-my-ticket-list-user"),

  createTicket: (data) =>
    requests.post("/ticket/v1/add-ticket-user", data),

  getTicketMessages: (id) =>
    requests.get(`/ticket/v1/get-ticket-messages-user/${id}`),

  userAnswerTicket: (data) =>
  requests.post("/ticket/v1/user-answer-ticket", data),
};



export default TicketService;